export function canRegisterInAnotherCategory({
  challengeType, categoryCount, hasRegistration, registrationsOpen,
}: {
  challengeType?: string;
  categoryCount: number;
  hasRegistration: boolean;
  registrationsOpen: boolean;
}): boolean {
  return hasRegistration && registrationsOpen && categoryCount > 1 &&
    ["poco", "tournament"].includes(String(challengeType || "").trim().toLowerCase());
}
